import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { QRCodeSVG } from 'qrcode.react';
import { TypedMemo } from '../common/types';
import { buildHandoffUrl } from './mobileAppLinks';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole handoff; each part uses its own slice of it */
import styles from './MobileApps.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface HandoffQrProps {
  next?: string;
}

/** The QR code with the handoff link (design 1a, 1b). The phone camera opens the app or the store. */
const HandoffQrComponent: React.FC<HandoffQrProps> = ({ next }) => {
  const intl = useIntl();
  const url = useMemo(() => buildHandoffUrl(window.location.origin, next), [next]);

  return (
    <div className={styles.qrColumn}>
      <div className={styles.qr}>
        <QRCodeSVG
          value={url}
          size={176}
          level="M"
          title={intl.formatMessage({
            id: 'app.sml.mobileApps.qr.title',
            defaultMessage: 'QR code that opens the MUSIC24 app',
          })}
        />
      </div>
      <span className={styles.qrCaption}>
        {intl.formatMessage({ id: 'app.sml.mobileApps.qr.caption', defaultMessage: 'Scan with the camera' })}
      </span>
    </div>
  );
};

export const HandoffQr = TypedMemo(HandoffQrComponent);
